import type { Transaction } from './finance.ts';

export const BULK_TRANSACTION_LIMIT = 2000;

/** A selection is a snapshot of explicit IDs, never a live "all future rows" flag. */
export function toggleTransactionSelection(current: ReadonlySet<string>, id: string) {
  const next = new Set(current);
  if (next.has(id)) next.delete(id); else next.add(id);
  return next;
}
export function selectTransactionPage(current: ReadonlySet<string>, rows: Pick<Transaction, 'id'>[], checked: boolean) {
  const next = new Set(current);
  for (const row of rows) { if (checked) next.add(row.id); else next.delete(row.id); }
  return next;
}
export function retainTransactionSelection(current: Set<string>, available: ReadonlySet<string>) {
  const next = new Set([...current].filter((id) => available.has(id)));
  return next.size === current.size ? current : next;
}
